<!-- Info Modal Overlay -->
@if (showInfoModal) {
  <div class="charity-modal-overlay">
    <div class="charity-modal-card">
      <h2 class="charity-modal-title">{{ 'add.charity.dialog.title' | translateLang }}</h2>
      <p class="charity-modal-body">{{ 'add.charity.dialog.body' | translateLang }}</p>
      <p class="charity-modal-signature">{{ 'add.charity.info.signature' | translateLang }}</p>
      <div class="charity-modal-footnote">
        <p class="charity-modal-footnote-text">{{ 'add.charity.dialog.footnote' | translateLang }}</p>
      </div>
      <button type="button" class="lg-button form-next-button charity-modal-okay" (click)="onDialogOkay()">
        {{ 'add.charity.dialog.okay' | translateLang }}
      </button>
    </div>
  </div>
}

<div class="charity-page">

  @if (pageLoading) {
    <app-loading-overlay [visible]="true" [indeterminate]="true"></app-loading-overlay>
  } @else {

  @if (currentStep === 1) {

    <!-- Page Header -->
    <div class="charity-header">
      <div class="charity-title-group">
        <h1 class="charity-title">{{ 'add.charity.title' | translateLang }}</h1>
        <p class="charity-subtitle">{{ 'add.charity.subtitle' | translateLang }}</p>
      </div>
      @if (fundService.selectedFund() && fundService.funds().length > 0) {
        <app-fund-switcher
          [funds]="fundService.funds()"
          [selectedFundId]="fundService.selectedFundId()"
          [variant]="'yellow'"
          [numberFormat]="numberFormatConfig"
          (fundChanged)="onFundChanged($event)"
        />
      }
    </div>
  }

  <!-- Step Indicator -->
  <div class="stepper-container">
    <app-stepper [steps]="stepperSteps" [activeStepIndex]="activeStepIndex" />
  </div>

  <!-- Step 1: Form -->
  <div [hidden]="currentStep !== 1">
    <div class="form-content">
      <app-add-charity-form
        [fund]="currentFund"
        (formChangedEvent)="formData = $event"
        (formIsValid)="formIsValid = $event"
      />
    </div>
    <div class="button-container">
      <p class="step-counter">{{ 'contribute.step_counter' | translateLang: { current: currentStep, total: stepperSteps.length } }}</p>
      <button
        type="button"
        class="lg-button form-next-button"
        [disabled]="!formIsValid"
        (click)="goToSummary()"
      >
        {{ 'common.next' | translateLang }}
      </button>
    </div>
  </div>

  <!-- Step 2: Summary -->
  @if (currentStep === 2) {
    @if (loading) {
      <app-loading-overlay [visible]="true" [indeterminate]="true"></app-loading-overlay>
    } @else {
      <div class="form-content">
        @if (showError) {
          <div class="alert-box">{{ 'add.charity.error.server' | translateLang }}</div>
        }
        <app-add-charity-summary
          [displayData]="summaryData"
        />
      </div>
      <div class="button-container">
        <p class="step-counter">{{ 'contribute.step_counter' | translateLang: { current: currentStep, total: stepperSteps.length } }}</p>
        <div class="button-row">
          <button type="button" class="lg-button form-back-button" (click)="goToForm()">
            {{ 'common.back' | translateLang }}
          </button>
          <button type="button" class="lg-button form-next-button" (click)="onSubmit()">
            {{ 'common.next' | translateLang }}
          </button>
        </div>
      </div>
    }
  }

  <!-- Step 3: Confirmation -->
  @if (currentStep === 3) {
    <div class="form-content">
      <div class="completion-card">
        <h2 class="completion-title">{{ 'add.charity.confirmation.title' | translateLang }}</h2>
        <p class="completion-subtitle">{{ 'add.charity.confirmation.message' | translateLang }}</p>
      </div>
    </div>
    <div class="button-container">
      <p class="step-counter">{{ 'contribute.step_counter' | translateLang: { current: currentStep, total: stepperSteps.length } }}</p>
      <button type="button" class="lg-button form-back-button" (click)="goToGrant()">
        {{ 'add.charity.confirmation.back_to_grant' | translateLang }}
      </button>
    </div>
  }

  } <!-- end @else pageLoading -->

</div>
